module.exports = __webpack_public_path__ + "static/media/token history.bc81b6f1.svg";